import { sectionRenderer } from '@theme/section-renderer';
import { startViewTransition } from '@theme/utilities';

class WellnessCollectionSort extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
    this.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
    this.removeEventListener('submit', this.#handleSubmit);
  }

  get sectionId() {
    const sectionId = this.getAttribute('section-id');
    if (!sectionId) throw new Error('Section ID is required');
    return sectionId;
  }

  #handleChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    if (event.target.name !== 'sort_by') return;

    this.#updateSort(event.target);
  };

  #handleSubmit = (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;

    const select = event.target.querySelector('select[name="sort_by"]');
    if (!(select instanceof HTMLSelectElement)) return;

    event.preventDefault();
    this.#updateSort(select);
  };

  async #updateSort(select) {
    const form = select.form;
    if (!form) return;

    const nextUrl = new URL(window.location.href);
    const actionUrl = new URL(form.action, window.location.origin);

    nextUrl.pathname = actionUrl.pathname;
    nextUrl.searchParams.delete('page');
    nextUrl.searchParams.delete('section_id');
    nextUrl.searchParams.set('sort_by', select.value);
    nextUrl.hash = '';

    history.pushState({ sortBy: select.value }, '', nextUrl.toString());

    this.#setLoading(true);

    try {
      await startViewTransition(() => sectionRenderer.renderSection(this.sectionId, { cache: false, url: nextUrl }), [
        'product-grid',
      ]);
    } finally {
      this.#setLoading(false);
    }
  }

  #setLoading(isLoading) {
    const select = this.querySelector('select[name="sort_by"]');
    const results = document.querySelector('results-list');

    if (select instanceof HTMLSelectElement) select.disabled = isLoading;
    this.setAttribute('aria-busy', String(isLoading));
    results?.setAttribute('aria-busy', String(isLoading));
  }
}

if (!customElements.get('wellness-collection-sort')) {
  customElements.define('wellness-collection-sort', WellnessCollectionSort);
}
